export default __webpack_public_path__ + "static/media/crisp2.99e1347d.png";